import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpService } from 'app/resources/services/http.service';
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { SessionService } from 'app/resources/services/session-service.service';
import { DefineBootboxId } from 'app/resources/classes';

@Injectable()

export class DownloadService {

  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public processando: boolean;
  public fileName: string;
  public fileData: any;

  constructor(public http: HttpService,
    public sanitizer: DomSanitizer,
    public httpN: Http,
    public sessionService: SessionService) {

    this.processando = false;
    this.fileName = undefined;
    this.fileData = undefined;
  }

  public getFile(url) {
    this.processando = true;

    this.http.pathRest().get(url, true)
      .subscribe(
        sucesso => {
          const urlSegura = this.sanitizer.bypassSecurityTrustUrl(sucesso.json().base64);
          this.fileData = urlSegura;
          this.processando = false;
        },
        erro => {
          this.processando = false;
          this.bootboxAlertComId.alerta(erro.text());
        });
  }

  private toFile(name, type, content) {
    const blob = new Blob([content], { type: type });
    if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
      window.navigator.msSaveOrOpenBlob(blob, name);
    } else {
      const linkElement = document.createElement('a');
      linkElement.setAttribute('href', window.URL.createObjectURL(blob));
      linkElement.setAttribute('download', name);

      const clickEvent = new MouseEvent('click', {
        'view': window,
        'bubbles': true,
        'cancelable': false
      });
      linkElement.dispatchEvent(clickEvent);
    }
  }

  public responseToFile(response) {
    const headers = response.headers;
    const linkElement = document.createElement('a');
    const blob = new Blob([response._body], { type: headers.get('content-type') });
    linkElement.setAttribute('href', window.URL.createObjectURL(blob));
    linkElement.setAttribute('download', this.fileName);
    const clickEvent = new MouseEvent('click', {
      'view': window,
      'bubbles': true,
      'cancelable': false
    });
    linkElement.dispatchEvent(clickEvent);
  }

  private base64ToArrayBuffer(base64) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  public getDownload(path: string, transacao?: boolean) {
    const header: Headers = new Headers();
    const requestOpt = new RequestOptions();
    header.append('Authorization', 'Basic ' + this.sessionService.getAuthBasic());
    header.append('Content-Type', 'application/json');

    requestOpt.headers = header;
    if (transacao !== true) {
      requestOpt.responseType = 2;
    }
    this.processando = true;
    this.httpN.get(this.http.pathRest().path + path, requestOpt)
      .subscribe(
        sucesso => {
          if (transacao) {
            const arquivo = sucesso.json();
            this.toFile(arquivo.fileName, arquivo.contentType, this.base64ToArrayBuffer(arquivo.base64));
            this.processando = false;
          } else {
            this.responseToFile(sucesso);
          }

          this.processando = false;
        }, erro => {
          this.bootboxAlertComId.alerta(erro._body);
          this.processando = false;
        });

  }

  public getComprovante(transacao) {
    this.fileName = undefined;
    this.fileData = undefined;

    if (transacao.origem === 'pagamento_boleto' || transacao.origem === 'pagamento_conta_consumo') {
      this.getDownload('cartao/pagamento/transacao/' + transacao.id + '/' + transacao.uuid + '/comprovante/', true);
    } else if (transacao.origem === 'transferencia_bancaria') {
      this.getDownload('cartao/transferencia/bancaria/' + transacao.id + '/' + transacao.uuid + '/comprovante/', true);
    } else if (transacao.origem === 'pix') {
      this.getComprovantePix('cartao/transferencia/bancaria/' + transacao.id + '/' + transacao.uuid + '/comprovante/pix', transacao);
    } else if (transacao.origem === 'boleto_transfeera' || transacao.origem === 'pagamento_conta_consumo_transfeera') {
      this.getComprovanteBoleto('cartao/pagamento/transacao/' + transacao.origemId + '/comprovante/transfeera', transacao);
    }
  }

  getComprovanteBoleto(path: string, transacao: any) {
    const header: Headers = new Headers();
    const requestOpt = new RequestOptions();
    header.append('Authorization', 'Basic ' + this.sessionService.getAuthBasic());
    header.append('Content-Type', 'application/json');

    requestOpt.headers = header;
    if (transacao !== true) {
      requestOpt.responseType = ResponseContentType.Json;
    }
    this.processando = true;
    this.httpN.get(this.http.pathRest().path + path, requestOpt)
      .subscribe(
        success => {
          this.processando = false;
          const data = success.json();
          if (data.status === 'concluido' || data.status === 'recusado' || data.status === 'devolvido') {
            this.getDownloadBoleto(data);
          } else {
            this.bootboxAlertComId.alerta(`Não existe comprovante para a transação! Situação: ${data.status}`);
          }
        }, error => {
          this.processando = false;
          this.bootboxAlertComId.alerta(error.text());
        })
  }

  public getComprovantePix(path: string, transacao: any) {
    const header: Headers = new Headers();
    const requestOpt = new RequestOptions();
    header.append('Authorization', 'Basic ' + this.sessionService.getAuthBasic());
    header.append('Content-Type', 'application/json');

    requestOpt.headers = header;
    if (transacao !== true) {
      requestOpt.responseType = ResponseContentType.Json;
    }
    this.processando = true;
    this.httpN.get(this.http.pathRest().path + path, requestOpt)
      .subscribe(
        success => {
          this.processando = false;
          const data = success.json();
          if (data.status === 'CONCLUIDA' || data.status === 'RECUSADA') {
            this.getDownloadPix(data);
          } else {
            this.bootboxAlertComId.alerta(`Não existe comprovante para a transação! Situação: ${data.status}`);
          }
        }, error => {
          this.processando = false;
          this.bootboxAlertComId.alerta(error.text());
        })
  }

  private getDownloadBoleto(boleto: any) {
    const headers: Headers = new Headers();
    const httpOptions = {
      headers: new Headers(
        {
          'Accept': 'application/zip',
          'responseType': 'blob'
        }
      )
    };

    headers.append('Content-Type', 'application/zip');
    this.processando = true;
    this.http.pathApiReports()
      .post('v1/reports/payments/pdf', boleto, false, httpOptions)
      .subscribe
      (
        sucesso => {
          this.processando = false;
          const arquivo = sucesso.json()
          this.toFile(arquivo.fileName, arquivo.contentType, this.base64ToArrayBuffer(arquivo.base64));

        }, erro => {
          this.processando = false;
          this.bootboxAlertComId.alerta(erro.text());
        });
  }

  private getDownloadPix(cashOut: any) {
    const headers: Headers = new Headers();
    const httpOptions = {
      headers: new Headers(
        {
          'Accept': 'application/zip',
          'responseType': 'blob'
        }
      )
    };

    headers.append('Content-Type', 'application/zip');
    this.processando = true;
    this.http.pathApiReports()
      .post('v1/reports/cashouts/pdf', cashOut, false, httpOptions)
      .subscribe
      (
        sucesso => {
          this.processando = false;
          const arquivo = sucesso.json()
          this.toFile(arquivo.fileName, arquivo.contentType, this.base64ToArrayBuffer(arquivo.base64));

        }, erro => {
          this.processando = false;
          this.bootboxAlertComId.alerta(erro.text());
        });
  }

  private getDownloadPagamento(pagamento: any) {
    const headers: Headers = new Headers();
    const httpOptions = {
      headers: new Headers(
        {
          'Accept': 'application/zip',
          'responseType': 'blob'
        }
      )
    };

    headers.append('Content-Type', 'application/zip');
    this.processando = true;
    this.http.pathApiReports()
      .post('v1/reports/payments/pdf', pagamento, false, httpOptions)
      .subscribe
      (
        sucesso => {
          this.processando = false;
          const arquivo = sucesso.json()
          this.toFile(arquivo.fileName, arquivo.contentType, this.base64ToArrayBuffer(arquivo.base64));

        }, erro => {
          this.processando = false;
          this.bootboxAlertComId.alerta(erro.text());
        });
  }

  public getSacAnexo(anexo) {
    this.fileName = anexo.nome;
    this.getDownload('anexo/' + anexo.id + '/' + anexo.uuid + '/arquivo/');
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/services/download.service.ts